import { ExternalProvider } from '../../enums/external-provider.enum'
import { OpenAISTTModel } from '../../enums/openai/openai-stt.language.enum'

export const sttModels = {
  [ExternalProvider.OpenAI]: OpenAISTTModel
}